import { updates } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">随时掌握皮皮喵漫画的最新资讯和更新消息</p>
        </div>
        <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200 space-y-6">
          {updates.map((item) => (
            <div key={item.id} className="relative">
              <div className="absolute -left-[29px] md:-left-[33px] top-1 w-4 h-4 rounded-full bg-primary-500 border-4 border-background-50"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mb-1">
                <span className="text-xs text-foreground-500 bg-background-200/70 px-1.5 py-0.5 rounded whitespace-nowrap w-fit">{item.date}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap w-fit ${
                  item.tag === '新番上线' ? 'bg-accent-100 text-accent-700' :
                  item.tag === '更新通知' ? 'bg-primary-100 text-primary-700' :
                  item.tag === '活动公告' ? 'bg-secondary-100 text-secondary-700' :
                  item.tag === '功能上线' ? 'bg-secondary-100 text-secondary-700' :
                  'bg-background-200 text-foreground-600'
                }`}>{item.tag}</span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 leading-relaxed">{item.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}